module.exports = __webpack_public_path__ + "img/Logo.bf8e417c.svg";